import { api } from '@api/api2';
import type { GetResidentsListPayload } from './types';

export const getResidentsList = (payload: GetResidentsListPayload) =>
  api.v4('get', 'residents-new/search', payload);
